var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(false)?_c('v-container',{staticClass:"py-8"},[_c('MultipleCouponForm')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }